/**
 * Ported from the Slate-era webpack bundle (src/scripts/templates/page.landing.js).
 * Requires splide.js (window.Splide) and countup.min.js (window.countUp) loaded first.
 */
(function () {
var CountUp = window.countUp.CountUp;

document.addEventListener("DOMContentLoaded", () => {
  const resultsSlide = document.querySelector(".results .splide");
  const ratingsSlide = document.querySelector(".ratings .splide");
  if (resultsSlide) {
    new Splide(resultsSlide, {
      perPage: 1.5,
      focus: "center",
      trimSpace: false,
      arrows: false,
      gap: 20,
      snap: true
    }).mount();
  }
  if (ratingsSlide) {
    new Splide(ratingsSlide, {
      perPage: 1,
      focus: "center",
      arrows: false,
      gap: 20
    }).mount();
  }
  const countUpId = "countUp";
  const countUpEl = document.querySelector("#" + countUpId);
  if (countUpEl) {
    let countUp = new CountUp(countUpId, 1300000, {
      startVal: 1000000,
      duration: 3600
    });
    if (!countUp.error) {
      countUp.start();
    }
  }

  const qtyInput = document.querySelector(".quantity");
  let qtyValue = 1;

  if (qtyInput) {
    // Reference the hidden input for quantity
    const hiddenQtyInput = qtyInput.querySelector(
      'input[name^="items"][name$="[quantity]"]'
    );

    const onQtyButtonClick = function (event) {
      event.preventDefault();
      const previousValue = qtyInput.input.value;

      event.target.name === "plus"
        ? qtyInput.input.stepUp()
        : qtyInput.input.stepDown();

      if (previousValue !== qtyInput.input.value) {
        qtyInput.input.dispatchEvent(qtyInput.changeEvent);
        qtyValue = qtyInput.input.value;

        // Update the hidden quantity input if it exists
        if (hiddenQtyInput) {
          hiddenQtyInput.value = qtyValue;
        }
      }
    };

    qtyInput.input = qtyInput.querySelector("input");
    qtyInput.changeEvent = new Event("change", { bubbles: true });
    qtyInput.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", (event) => {
        onQtyButtonClick(event);
      })
    );
  }

  const selectVariantDetails = document.querySelectorAll("details.variant");
  const selectVariantElements = document.querySelectorAll(
    "[data-select-variant]"
  );

  if (selectVariantElements) {
    selectVariantElements.forEach(function (selectVariant) {
      selectVariant.addEventListener("change", (event) => {
        if (event.target.value) {
          const selectVariantInputs = document.querySelectorAll(
            '[data-select-variant] input[value="' + event.target.value + '"]'
          );
          selectVariantInputs.forEach(function (input) {
            input.checked = true;
          });
          selectVariantDetails.forEach(function (details) {
            details.removeAttribute("open");
            if (event.target.value == details.dataset.variantId) {
              details.setAttribute("open", "");
            }
          });
        }
      });
    });
  }

  const countdownContainer = document.getElementById("flat-tummy-bundles");
  const countdown = document.getElementById("countdown");
  const countdownkey = "flattummyoffer";
  let countDownDate;

  if (countdown) {
    const storagekey = sessionStorage.getItem(countdownkey);

    // Set the date we're counting down to
    if (storagekey) {
      countDownDate = storagekey;
    } else {
      countDownDate = new Date(Date.now() + 5 * 60000).getTime();
      sessionStorage.setItem(countdownkey, countDownDate);
    }

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for minutes and seconds
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element
      countdown.innerHTML = minutes + "m " + seconds + "s ";

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        countdown.innerHTML = "Offer Expired";
        countdownContainer.classList.remove("flash-sale");
      }
    }, 1000);
  }
});

})();
